module.exports = __webpack_public_path__ + "img/hotel2.413df175.png";